module.exports = __webpack_public_path__ + "static/img/logo.c203a4a8.png";